import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { tableOptions } from "../../styles/tableStyle"
import { DialogWidget, SnackBarWidget } from "../../Widget";
import { Paper, Box, LinearProgress, Button, Typography, Tooltip } from "@mui/material"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TableSortLabel } from "@mui/material"
import TopAppBar from "../app/TopAppBar";
import { customStyles } from "../../styles/tableStyle"
import RegisterForm from "../user/RegisterForm"
import { AddCircle, Edit, Group } from "@mui/icons-material"
import UserProfile from "./UserProfile";
const { commons, util } = require("../../commons")



export default function ManageUsers() {

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [users, setUsers] = React.useState([]);
  const [user, setUser] = React.useState({})
  const [apiService, setApiService] = React.useState(false);
  const [dialogStatus, setDialogStatus] = React.useState(false);
  const [dialogType, setDialogType] = React.useState('');
  useEffect(() => {
    getUsers()
  }, [])


  const getUsers = () => {
    let params = { op: "getUser" };
    setApiService(true)
    commons.getAPIRes(params, "POST", "user").then(apiRes => {
      setApiService(false)
      setUsers(apiRes.result)

    });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleDialogClose = () => {
    setDialogStatus(false)
    setDialogType("")
  }

  const handleDialog = (e, key) => {
    setDialogStatus(true)
    setDialogType(key)
  };

  const handleProjectDialog = (e, key, item) => {
    setDialogStatus(true)
    setDialogType(key)
    setUser(item)
  };


  return (
    <Box spacing={2} style={{ width: '100%', flexDirection: 'column', display: 'flex' }}>
      <TopAppBar />
      <Typography variant="h6">Users</Typography>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flex: 1 }}></div>
        <Tooltip title={"Create User"} style={{ flex: 1 }}>
          <AddCircle onClick={(e) => handleDialog(e, "createUser")} />
        </Tooltip>
      </div>
      <TableContainer component={Paper} sx={{ alignSelf: 'center', maxWidth: 650 }}>
        <Table size={"small"} aria-label="simple table">
          <TableHead style={tableOptions.headerStyle}>
            <TableRow>
              <TableCell style={{ textAlign: 'left' }}>Name</TableCell>
              <TableCell style={{ textAlign: 'left' }}>Email</TableCell>
              <TableCell style={{ textAlign: 'left' }}>Role</TableCell>
              <TableCell style={{ textAlign: 'center' }}>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (<TableRow style={tableOptions.cellStyle}>
                  <TableCell style={{ textAlign: 'left' }}> {util.titleCase(row.name)} </TableCell>
                  <TableCell style={{ textAlign: 'left' }}> {row.email} </TableCell>
                  <TableCell style={{ textAlign: 'left' }}> {row.role ? row.role.toLowerCase() : ''} </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    <Tooltip title={"Edit " + util.titleCase(row.name)}>
                      <Edit onClick={(e) => handleProjectDialog(e, "updateUser", row)} />
                    </Tooltip>
                  </TableCell>


                </TableRow>)
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{ alignSelf: 'center', maxWidth: 650 }}
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={users.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />


      {dialogStatus && dialogType === "createUser" ?
        <DialogWidget
          maxWidth="sm"
          dialogTitle={"Create User"}
          okTitle={"Submit"}
          negOk={false}
          dialogContent={<RegisterForm closeDialog={handleDialogClose} reloadPage={getUsers} role={true} title={""} />}
        /> : false}

      {dialogStatus && dialogType === "updateUser" ?
        <DialogWidget
          maxWidth="sm"
          dialogTitle={"Update User"}
          okTitle={"Submit"}
          negOk={false}
          dialogContent={<UserProfile closeDialog={handleDialogClose} user={user} reloadPage={getUsers} title={""} />}
        /> : false}


    </Box >
  );
}


